var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#F0FDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.8369C31.4559 28.5683 32.7041 29.742 33.6152 31.2096C33.7956 31.5003 33.8858 31.6456 33.917 31.8468C33.9804 32.2558 33.7008 32.7585 33.3199 32.9204C33.1325 33 32.9216 33 32.5 33M28 23.5322C29.4817 22.7959 30.5 21.2669 30.5 19.5C30.5 17.7331 29.4817 16.2041 28 15.4678M26 19.5C26 21.9853 23.9852 24 21.5 24C19.0147 24 17 21.9853 17 19.5C17 17.0147 19.0147 15 21.5 15C23.9852 15 26 17.0147 26 19.5ZM14.5592 30.9383C16.1535 28.5446 18.6693 27 21.5 27C24.3306 27 26.8464 28.5446 28.4407 30.9383C28.79 31.4628 28.9646 31.725 28.9445 32.0599C28.9289 32.3207 28.7579 32.64 28.5495 32.7976C28.2819 33 27.9138 33 27.1776 33H15.8223C15.0861 33 14.718 33 14.4504 32.7976C14.242 32.64 14.071 32.3207 14.0554 32.0599C14.0353 31.725 14.2099 31.4628 14.5592 30.9383Z",
    stroke: "#166534",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconAction);
export default __webpack_public_path__ + "static/media/userIconAction.38e3438576748b01c3486adc43e90b6f.svg";
export { ForwardRef as ReactComponent };